import React from 'react'
import classNames from 'classnames'

export const Chip = ({ text, children, className, ...props }) => {
  return (
    <span {...props} className={classNames('search-mxd-chip', className)}>
      {text ?? children}
    </span>
  )
}
